import { HOLOGRAPHIC_COLORS } from "@colossus/contracts";
import type { RoleStyle } from "@colossus/contracts";

export const SOLID: RoleStyle = { kind: "solid" };

export const NO_ROLE_COLOUR = "#99aab5";
export const ROLE_SWATCHES = [
  NO_ROLE_COLOUR,
  "#1abc9c",
  "#2ecc71",
  "#3498db",
  "#9b59b6",
  "#e91e63",
  "#f1c40f",
  "#e67e22",
  "#e74c3c",
] as const;

export const fadeFrom = (from: string | null): string => {
  const at = ROLE_SWATCHES.findIndex((swatch) => swatch === from);
  return ROLE_SWATCHES[
    (Math.max(at, 0) + Math.floor(ROLE_SWATCHES.length / 2)) % ROLE_SWATCHES.length
  ]!;
};

interface RolePaint {
  readonly color: string | null;
  readonly gradient: string | null;
}

export const rolePaint = (color: string | null, style: RoleStyle): RolePaint => {
  if (style.kind === "holographic") {
    const { primary, secondary, tertiary } = HOLOGRAPHIC_COLORS;
    return {
      color: null,
      gradient: `linear-gradient(90deg, ${primary}, ${secondary}, ${tertiary})`,
    };
  }
  if (style.kind === "gradient" && color !== null) {
    return { color: null, gradient: `linear-gradient(90deg, ${color}, ${style.secondary})` };
  }
  return { color, gradient: null };
};
